import { Dialog, DialogContent } from '@components/shared/dialog'
import { DialogProps } from '@radix-ui/react-dialog'

export const JoinMailingListDialog = (props: DialogProps) => {
  return (
    <Dialog open={props?.open} onOpenChange={props?.onOpenChange}>
      <DialogContent className="!bg-white min-h-[320px]">
        <iframe
          src="https://embeds.beehiiv.com/07720538-79de-43af-998a-cea23afcf3be"
          data-test-id="beehiiv-embed"
          width="100%"
          height="320"
          style={{
            border: 'none',
            margin: 0,
            background: 'transparent',
          }}
        ></iframe>
      </DialogContent>
    </Dialog>
  )
}
